import React from 'react';
import * as S from './styles';

const TextContainer = (props = {}) => (
  <S.TextContainer order={props.order}>
    <div>{props.children}</div>
  </S.TextContainer>
);

export default TextContainer;
